// (c) TwistedMinds, Gerry Uytdenhouwen - 3 november 2026

/**
 * Pagination state after "Wissen": back to page 1 with period, archive and
 * machine filters off. Everything else (itemsPerPage, q, ...) is kept.
 * Returns a new object; the input is never mutated.
 */
export function resetFilters(pagination) {
    return {...pagination, page: 1, deliveryDay: '', archive: 0, onlyMachine: 0};
}

/**
 * Period buttons act as toggles: clicking the active one turns it off,
 * clicking another one switches to it.
 * Values: 'today' | 'yesterday' | 'weekly' | ''
 */
export function togglePeriod(current, clicked) {
    return clicked === current ? '' : clicked;
}
